import React from "react";
import "../styles/navbar.css";
import "../styles/search_bar.css";
// import SearchBar from "./SearchBar";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div onClick={() => navigate(`/`)} className="navbar-logo">
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="Trekkers Clan Logo"
          width="40"
          height="40"
        />
        <div href="/">
          <div className="navbar-text">Trekkers Clan</div>
          <div className="navbar-sub-text">United by mountains</div>
        </div>
      </div>
      {/* <SearchBar /> */}
      {/* <ul className={`navbar-links ${isMobileMenuOpen ? "show" : ""}`}>
        <li className={`nav-item ${activeLink === "events" ? "active" : ""}`}>
          <a href="#events" onClick={() => handleLinkClick("events")}>
            All Events
          </a>
        </li>
        <li className={`nav-item ${activeLink === "about" ? "active" : ""}`}>
          <a href="#about" onClick={() => handleLinkClick("about")}>
            About Us
          </a>
        </li>
        <li className={`nav-item ${activeLink === "contact" ? "active" : ""}`}>
          <a href="#contact" onClick={() => handleLinkClick("contact")}>
            Contact
          </a>
        </li>
      </ul>
      <div className="navbar-toggle" onClick={toggleMobileMenu}>
        <span className="toggle-bar"></span>
        <span className="toggle-bar"></span>
        <span className="toggle-bar"></span>
      </div> */}
    </nav>
  );
}

export default Navbar;
